import { render } from "./App.vue?vue&type=template&id=4d05cb52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d05cb52&lang=scss"

import exportComponent from "D:\\Microsoft VS Code Project\\mft_stock_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__